<template>
    <div style="background-color: #fafafa;">
        <van-nav-bar title="线索池" left-text="返回" left-arrow @click-left="onClickLeft" />
        <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
            <van-list v-model="loading" :finished="finished" @load="onLoad" finished-text="没有更多了">
                <div v-for="clue in list" class="card" :key="clue.uuid">
                    <table class="layout">
                        <tr>
                            <td class="avatar-box" rowspan="4">
                                <img :src="avatarUrl + clue.advisorIdavatar" class="avatar" alt="avatar">
                                <p class="advisor">{{clue.advisorIdname}}</p>
                            </td>
                            <td colspan="2" >
                                <div class="header">
                                    <span class="title">{{clue.companyName}}</span>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="2" class="content">
                                <p>
                                    <span class="iconfont icon-user"/>
                                    <span>{{clue.contactPer || '无'}}</span>
                                </p>
                                <p>
                                    <span class="iconfont icon-date"/>
                                    <span>{{clue.createTime}}</span>
                                </p>
                                <p>
                                    <span class="iconfont icon-beizhu"/>
                                    <span>{{clue.remark}}</span>
                                </p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <span class="icon iconfont icon-tiqu" @click="extract(clue.uuid,$event)"/>
                            </td>

                        </tr>
                    </table>
                </div>
            </van-list>
        </van-pull-refresh>
        <van-popup v-if="detailShow" v-model="detailShow" position="right">
            <thread-details :clue="clue" :type="type" @closeview="closePopup"></thread-details>
        </van-popup>
    </div>
</template>

<script>
    import {Tab, Tabs, Panel, Button, List, Search, Popup,PullRefresh,Toast,NavBar} from 'vant';
    import userInfo from '../store/userInfo';
    import threadService from "../service/threadService";
    import moment from "moment";
    import {formatMoney} from "../utils/money";
    import {formatDictionary} from "../utils/dictionary";
    import {API_URL} from "../common/config";
    import ThreadDetails from "./ThreadDetails";

    export default {
        data: function () {
            return {
                detailShow:false,
                selected: 0,
                searchParam: {},
                list: [],
                loading: false,
                finished: false,
                pageIndex: 0,
                value: '',
                show: false,
                refreshing: false,
                clueId:'',
                clue:{},
                showTime: true,
                activeKey: 0,
                contactTime: '',
                createTime: '',
                finishCreateTime: '',
                currDateType: 0,
                currCreateDateType: 0,
                currDisAdvisorDateType: 0,
                sourceValue: 0

            }
        },
        store: userInfo,
        components: {
            ThreadDetails,
            [Tab.name]: Tab,
            [NavBar.name]: NavBar,
            [Tabs.name]: Tabs,
            [Button.name]: Button,
            [PullRefresh.name]: PullRefresh,
            [Panel.name]: Panel,
            [List.name]: List,
            [Search.name]: Search,
            [Popup.name]: Popup,
        },
        computed: {
            userId() {
                return this.$store.getters.getUserId;
            },
            avatarUrl() {
                return API_URL + "/oa/common/attachment/showImage?id=";
            }
        },
        created: async function () {

        },
        methods: {
            async onLoad() {
                this.pageIndex++;
                let resp = await threadService.getCluePool(this.pageIndex, this.value);
                resp.data.Data.data.forEach(clue => {
                    clue.createTime = moment(clue.createTime).format('YYYY-MM-DD');
                    clue.amount = formatMoney(clue.expectMoney === undefined ? "" : clue.expectMoney);
                    clue.remark = clue.remark || '暂无备注';
                    clue.advisorId = clue.advisorId === undefined ? clue.creatorId  : clue.advisorId ;
                });
                formatDictionary(resp.data.Data.data, resp.data.Data.dictionary);
                this.loading = false;
                this.refreshing = false;
                formatDictionary(resp.data.Data.data, resp.data.Data.dictionary);
                this.list = [...this.list, ...resp.data.Data.data];
                this.finished = resp.data.Data.total <= this.list.length;
            },
            onSearch() {
                this.finished = false;
                this.loading = true;
                this.pageIndex = 0;
                this.list = [];
                this.onLoad();
            },
            onRefresh() {
                this.finished = false;
                this.pageIndex = 0;
                this.list = [];
                this.onLoad();
            },
            async extract(id,e){
                e.stopPropagation();
                let resp = await threadService.extract(id);
                if (resp.data.Status === '1') {
                    Toast.success('操作成功');
                    this.onSearch();
                } else {
                    Toast.fail(resp.data.Data);
                }
            },
            onClickLeft() {
                window.open('/colseWebView');
            },
            closePopup() {
                this.detailShow = false;
            }
        }
    };

</script>

<style>
    .van-popup--right{
        width:100%;
        height:100%;
    }
    .van-nav-bar {
        z-index: 99999;
    }
    .tabs {
        margin-top: 120px;
    }
</style>
